import { AUTH_USER_KEY } from '@/lib/constants/authentication'

const setCurrentUser = (user) => localStorage.setItem(AUTH_USER_KEY, JSON.stringify(user))

export default setCurrentUser
